import { render } from "./KreistagView.vue?vue&type=template&id=22719c9a&scoped=true"
import script from "./KreistagView.vue?vue&type=script&lang=js"
export * from "./KreistagView.vue?vue&type=script&lang=js"

import "./KreistagView.vue?vue&type=style&index=0&id=22719c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22719c9a"]])

export default __exports__